import { SITE } from '@/app/constants';

const IS_CHINA = SITE === 'china';

const CDN_BASE_URL = IS_CHINA
  ? 'https://image01-aliyun.vidu.zone/vidu/media-asset'
  : 'https://image01.cf.vidu.studio/vidu/media-asset';

/** S banner 素材文件名（带内容 hash）。 */
const ASSET_FILE_NAMES = {
  characters: 's1-characters-1bb22436.webp',
  bubbleSayHi: 's1-bubble-say-hi-e712f716.webp',
  bubbleHandHeart: 's1-bubble-hand-heart-d2c9b9ed.webp',
  // 注意：CDN 上该文件名为 sunglasse（无尾部 s），不是笔误
  bubbleWearSunglasses: 's1-bubble-wear-sunglasse-1ad9eeb8.webp',
  // 背景与移动端整图把标题文案烘焙在图里，必须与站点语言一致，故按 IS_CHINA 取：
  // 移动端 en 图只在 cf CDN（aliyun 上 404），zh 图只在 aliyun CDN（cf 上 403），
  // 恰好与站点域名对应（global→cf、china→aliyun），按站点取即正确。
  background: IS_CHINA ? 's2-banner-bg-zh-92541805.webp' : 's2-banner-bg-en-6a8494a9.webp',
  mobile: IS_CHINA ? 's2-banner-mobile-zh-2c8252d2.webp' : 's2-banner-mobile-en-855a23bf.webp',
} as const;

export type S1BannerAssetKey = keyof typeof ASSET_FILE_NAMES;

export const getS1BannerAsset = (key: S1BannerAssetKey): string => `${CDN_BASE_URL}/${ASSET_FILE_NAMES[key]}`;
